import { render, staticRenderFns } from "./StepConfiguration.vue?vue&type=template&id=5b5ba11e&scoped=true&lang=pug"
import script from "./StepConfiguration.vue?vue&type=script&lang=js"
export * from "./StepConfiguration.vue?vue&type=script&lang=js"
import style0 from "./StepConfiguration.vue?vue&type=style&index=0&id=5b5ba11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ba11e",
  null
  
)

export default component.exports